import { defineStore } from 'pinia'
import { nextTick,markRaw} from 'vue'

export const useScroll = defineStore('scroll', {
  state: () => ({
    target: null,
    lastScrollTop: 0
  }),
  actions: {
    register(target) {
      console.log('注册滚动容器:', target?.$el) // 添加调试日志
      this.target = markRaw(target)
    },
    // 滚动到底部
    async toBottom() {
      await nextTick()
      const doScroll = () => {
        if (!this.target) return
        try {
          if (this.target?.$el) {
            const container = this.target.$el
            container.scrollTop = container.scrollHeight
          }
        } catch (e) {
          console.error('滚动异常:', e)
        }
      }
      // 立即执行一次
      doScroll()
      // DynamicScroller 需要时间测量项目实际高度（默认 min-item-size=60 只是估算），
      // 等项目渲染并测量完成后 scrollHeight 才会更新为真实值，所以延迟重试
      setTimeout(doScroll, 100)
      setTimeout(doScroll, 300)
    },
    savePosition() {
      if (this.target?.$el) {
        this.lastScrollTop = this.target.$el.scrollTop
      }
    },
    restorePosition() {
      if (this.target?.$el) {
        this.target.$el.scrollTop = this.lastScrollTop
      }
    }
  }
})